define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/locale",
	"csi/sessionConstants",
	"./PrintComboButtonPlugin"
], function(def,Action,ActionFactory,locale,sessionConstants,PrintComboButtonPlugin) {

	return ActionFactory.declare("print", Action, {
		m_id: "ViewPrint",
		m_class: "iconPrint",
		classToolbarPlugin: PrintComboButtonPlugin,

		constructor: function(obj) {
			this.m_typeControl = def.ACTION_ICON;
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: disable if data size is empty, or larger than max data size allowed for use
			return ctx.view.hasContent() && !ctx.view.doesQueryTotalExceedMax() && this.inherited(arguments);
		},

		validate: function(/*Context*/ctx) {
			// summary: action not valid when already printing view or in popup
			if (ctx.bPrint || ctx.view.bPopup) {
				return false;
			}

			const max = sessionConstants.siteMaxExportSize;
			if (max && ctx.view.bSupportsQuerySettings) {
				this.m_tooltip = locale.tooltip(this.m_id + "Max", [max]);
			}

			return true;
		}
	});
});